module.exports = __webpack_public_path__ + "img/tab-background-left.dc9ad6fb.svg";